import { Component, OnInit, AfterViewInit } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, Validators, FormControl, ValidationErrors } from '@angular/forms';
import { Observable } from 'rxjs/Observable';
import { Subscription } from 'rxjs/Subscription';
import { IMultiSelectOption } from 'angular-2-dropdown-multiselect';

import { AuthenticationService } from '../shared/authentication.service';
import { CiprsRole, UserProfile } from '../shared/user';
import { CountyService } from '../shared/county.service';
import { CourtCase } from './../shared/court-case';
import { EventService } from './../shared/event.service';
import { JuvenileSearchConstants } from './juvenile-search-constants';
import { JuvenileSearchResponse } from './juvenile-search-response';
import { JuvenileSearchService } from './juvenile-search.service';
import { environment } from './../../environments/environment';
import { isNullOrUndefined } from 'util';
import { PAGER_CONTROL_VALUE_ACCESSOR } from 'ngx-bootstrap/pagination/pager.component';
import { asyncRequired, asyncPattern, asyncFromGreater, asyncMinInt, asyncMaxInt } from '../shared/field-validators';

@Component({
  selector: 'app-juvenile',
  templateUrl: './juvenile.component.html',
  styleUrls: ['./juvenile.component.less']
})

export class JuvenileComponent implements AfterViewInit, OnInit {

  private loggedInUser: UserProfile;
  userType: string;

  submitted = false;
  onBlurEventCalled = false;
  errors: string[] = [];
  countyServiceErrors: string[] = [];
  juvenileSearchFormGroup: FormGroup;
  private openAccordionName: 'juvenile' | 'caseNumber' = 'juvenile';
  requestSubscription: Subscription;

  searchCriteriaDescription: string;
  searchRecordLastUpdateDate: string;
  counties: IMultiSelectOption[] = [];
  countyList: string[] = [];
  minYear = JuvenileSearchService.getJuvenileStartYear();
  maxYear = JuvenileSearchService.getCurrentYear();

  private caseSearchResults: JuvenileSearchResponse;

  showFieldCodeFlag = false;

  isICMSReleased = true;

  // validation parameters and validators
  delayTime = 1000; // ms
  caseNumberRegExp: RegExp = new RegExp(/^\s*((?:19|20)?\d{2})?\s*(JB)\s*(\d{1,6})\s*$/, 'i');
  yearRegExp: RegExp = new RegExp(/^\s*((19|20)\d{2})\s*$/, 'i');
  yearValidators = [Validators.pattern(/^\s*((19|20)\d{2})\s*$/i), Validators.min(this.minYear), Validators.max(this.maxYear)];
  // tslint:disable-next-line:max-line-length
  yearAsyncValidtors = [asyncMaxInt(this.maxYear, this.delayTime), asyncMinInt(this.minYear, this.delayTime), asyncPattern(this.yearRegExp, this.delayTime)];
  caseNumberValidators = [Validators.required, Validators.pattern(this.caseNumberRegExp)];
  caseNumberAsyncValidators = [asyncPattern(this.caseNumberRegExp, this.delayTime)];

  constructor(private authenticationService: AuthenticationService,
    private juvenileSearchService: JuvenileSearchService,
    protected eventService: EventService,
    private formBuilder: FormBuilder,
    private countyService: CountyService) {
    this.loggedInUser = authenticationService.getCurrentUser();
    this.userType = this.isDefenseAttorneyUser() ? 'DEFENSE' : 'DISTRICT';
  }

  openDisclaimer() {
    console.log('access the opening disclaimer');
    this.eventService.openDisclaimer('juvenile');
  }

  isDefenseAttorneyUser(): boolean {
    return ((this.loggedInUser.roleName === CiprsRole.Defense_Attorney) || (this.loggedInUser.roleName === CiprsRole.Public_Defender));
  }
  isDistrictAttorneyUser(): boolean {
    return this.loggedInUser.roleName === CiprsRole.District_Attorney;
  }

  ngOnInit() {
    // Load Non Odyssey county name list from backend
    this.countyServiceErrors = [];

    if (this.countyService.getNonOdysseyCounties().length < 1) {
      this.countyService.loadNonOdysseyCounties().subscribe(response => {
          this.countyService.setNonOdysseyCounties(response.data.sort());
          this.counties = this.countyService.getNonOdysseyCounties().map(i => { return { 'id': i, 'name': i }; });
          this.countyList = this.countyService.getNonOdysseyCounties();
          if (this.countyList.length < 100) {
            this.isICMSReleased = true;
          }
          this.resetForms();
        },
          errorMessage => { this.countyServiceErrors.push(errorMessage); }
      );
    } else {
      this.counties = this.countyService.getNonOdysseyCounties().map(i => { return { 'id': i, 'name': i }; });
      this.countyList = this.countyService.getNonOdysseyCounties();
    }
    
    // const yearValidators = [Validators.pattern(/^\s*((19|20)\d{2})\s*$/i), Validators.min(this.minYear), Validators.max(this.maxYear)];

    this.juvenileSearchFormGroup = this.formBuilder.group({
      /*caseLookup: this.formBuilder.group({
        county: ['', Validators.required],
        caseNumber: ['',
          [Validators.required,
           Validators.pattern(/^\s*((?:19|20)?\d{2})?\s*(JB)\s*(\d{1,6})\s*$/i)]
        ]
      }), */
      caseLookup: this.formBuilder.group({
        county: ['', Validators.required],
        caseNumber: ['', [Validators.required], this.caseNumberAsyncValidators]
      }),

      nameSearch: this.formBuilder.group({
        userType: [this.userType],
        searchBy: ['Name', []],
        searchValue: ['', Validators.required],
        // searchValueByName: ['',Validators.required],
        // searchValue: [''],
        counties: [[], []],
        // fromYear: [this.minYear, yearValidators],
        // toYear: [this.maxYear, yearValidators],
        fromYear: [this.minYear, null, this.yearAsyncValidtors],
        toYear: [this.maxYear, null, this.yearAsyncValidtors],
        casesPageNumber: []
      }, // {validator: Validators.compose([this.validateNcJoinNumber, this.isFromYearGreater])})
        {
          validator: Validators.compose([this.validateNcJoinNumber]),
          asyncValidator: [asyncFromGreater('fromYear', 'toYear', this.delayTime)]
        })
    });

    this.juvenileSearchFormGroup.get('caseLookup').disable();
/* 
    this.countyService.getNonOdysseyCountiesLoadedEvent().subscribe((isLoaded: boolean) => {
      this.counties = this.countyService.getNonOdysseyCounties().map(i => { return { 'id': i, 'name': i }; });
    });
     */
  }

  ngAfterViewInit() {
    this.resetForms();
    $('body').on('click', (event) => {
      let val: any = event.target;
      let caseNumber: any = this.juvenileSearchFormGroup.get('caseLookup.caseNumber');
      if (caseNumber.value === null && this.onBlurEventCalled && val !== null && val !== 'undefined'
        && val.id !== null && val.id !== 'undefined' && val.id !== 'juvenile-start-over-btn') {
        this.juvenileSearchFormGroup.get('caseLookup.caseNumber').setErrors({ 'blur': true, 'required': true });
      }
    });
  }

  selectAccordion(accordionGroupName: 'juvenile' | 'caseNumber', event: any): void {

    if (accordionGroupName === this.openAccordionName) {
      event.stopPropagation();
      return;
    }

    this.openAccordionName = accordionGroupName;
    if (accordionGroupName === 'caseNumber') {
      this.juvenileSearchFormGroup.get('caseLookup').enable();
      this.juvenileSearchFormGroup.get('nameSearch').disable();
      this.eventService.focusField('juvenile-case-number-input');
    } else if (accordionGroupName === 'juvenile') {
      this.juvenileSearchFormGroup.get('caseLookup').disable();
      this.juvenileSearchFormGroup.get('nameSearch').enable();
      this.eventService.focusField('juvenile-last-name-input');
    }
  }

  private executeSearch(): Observable<JuvenileSearchResponse> {

    const county: string = this.juvenileSearchFormGroup.get('caseLookup.county').value;
    const caseNumber: string = (this.juvenileSearchFormGroup.get('caseLookup.caseNumber').value + '').toUpperCase();
    let name = '';
    if (this.isDefenseAttorneyUser()) {
      name = this.loggedInUser.user.commonName;
    }

    if (this.openAccordionName === 'caseNumber') {
      this.searchCriteriaDescription
        // tslint:disable-next-line:max-line-length
        = JuvenileSearchService.getJuvenileSearchCriteriaDescription(this.juvenileSearchFormGroup.value.nameSearch, county, caseNumber, name);
      return this.juvenileSearchService.juvenileSearch(this.juvenileSearchFormGroup.value.nameSearch, county, caseNumber);
    } else {
      this.searchCriteriaDescription
        = JuvenileSearchService.getJuvenileSearchCriteriaDescription(this.juvenileSearchFormGroup.value.nameSearch, null, null, name);
      return this.juvenileSearchService.juvenileSearch(this.juvenileSearchFormGroup.value.nameSearch, null, null);
    }
  }

  onSearch() {
    this.caseSearchResults = null;
    this.searchCriteriaDescription = null;
    this.juvenileSearchFormGroup.get('nameSearch.casesPageNumber').setValue(null);
    this.search();
    this.scrollWindowIfNecessary();
  }

  private search(gettingNext = false) {
    this.errors = [];

    if (this.requestSubscription) {
      this.requestSubscription.unsubscribe();
    }

    if (!gettingNext) {
      this.cancelAdditionalOutstandingRequests();
    }


    // TODO: debate if the above code should execute when submitting an invalid form
    this.submitted = true;

    if (this.juvenileSearchFormGroup.invalid) {
      return;
    }

    // if (!(this.juvenileSearchFormGroup.invalid && this.isDefenseAttorneyUser())) {
    //     return;
    // }
    this.submitted = false; // TODO: is this the best way to manage the submitted flag?

    this.requestSubscription = this.executeSearch()
      .subscribe(searchResults => {
        const currentSearchResultCases = (this.caseSearchResults && this.caseSearchResults.cases) || [];
        const currentPageNumber = Number(this.juvenileSearchFormGroup.get('nameSearch.casesPageNumber').value) || 1;
        this.caseSearchResults = {
          cases: currentSearchResultCases.concat(...searchResults.cases),
          pageNumber: currentPageNumber,
          pageSize: JuvenileSearchConstants.PAGE_SIZE,
          totalRecords: searchResults.totalRecords
        };
      },
        (errorMessage: string) => this.errors.push(errorMessage));
  }

  private scrollWindowIfNecessary(): void {
    // when clicking on search button for party name search
    if (!this.caseSearchResults
      && this.errors.length) {
      document.documentElement.scrollTop = 0;
    } else {
      // If we're in a scenario where search results go under the search criteria, animate scrolling to results
      if ($(window).width() < 992) {
        this.scrollToSearchResults();
      }
    }
  }

  private scrollToSearchResults(): void {
    const searchResults = $('#juvenile-search-results-div');
    $('html, body').animate({
      scrollTop: $(searchResults).offset().top
    }, 500);
  }

  private resetForms() {
    this.submitted = false;
    this.juvenileSearchFormGroup.reset();
    this.juvenileSearchFormGroup.clearValidators();

    this.juvenileSearchFormGroup.get('nameSearch.searchBy').setValue('Name');
    this.juvenileSearchFormGroup.get('nameSearch.fromYear').setValue(2008);
    this.juvenileSearchFormGroup.get('nameSearch.toYear').setValue(this.maxYear);
    this.juvenileSearchFormGroup.get('nameSearch.casesPageNumber').setValue(null);

    const userCounty = this.authenticationService.getCurrentUser().authorization.geoName;
    setTimeout(() => {
      if (this.countyList.indexOf(userCounty) > -1) {
        this.juvenileSearchFormGroup.get('caseLookup.county').setValue(userCounty);
        this.juvenileSearchFormGroup.get('nameSearch.counties').setValue([userCounty]);
      } else {
        this.juvenileSearchFormGroup.get('caseLookup.county').setValue(this.countyService.getNonOdysseyCounties()[0]);
        this.juvenileSearchFormGroup.get('nameSearch.counties').setValue(this.countyService.getNonOdysseyCounties());
      }
    }, 0);

    const fieldToFocus = this.openAccordionName === 'caseNumber' ?
      'juvenile-case-number-input' : 'juvenile-last-name-input';
    this.eventService.focusField(fieldToFocus);

    // TODO:  remove this when development is complete.  Ron (Note: with production flag , it can be kept - daoxi 04/18)
    if (!environment.production) {
      //   this.juvenileSearchFormGroup.get('caseLookup.caseNumber').setValue('17JB123456');
    }
  }

  private cancelAdditionalOutstandingRequests() {
    if (this.requestSubscription) {
      this.requestSubscription.unsubscribe();
    }
  }

  startOver() {

    this.caseSearchResults = null;
    this.searchCriteriaDescription = null;
    this.resetForms();
    this.raiseError();
  }

  raiseError() {
    if (!this.onBlurEventCalled) {
      this.juvenileSearchFormGroup.get('caseLookup.caseNumber').setErrors({ 'blur': true, 'required': true });
    }
  }

  resetSubmissionFlag() {
    // this.submitted = false;
    // this.juvenileSearchFormGroup.reset();
    this.juvenileSearchFormGroup.setErrors(null);
    this.juvenileSearchFormGroup.setErrors(null);
  }

  /**
    * Generate display value representing the selected multi-select dropdown values.
    * @return {string} Formatted string representing the selected dropdown values.
    */
  getSelectedCounties(): string {
    // Note: this code depends on the naming pattern of the form controls and the instance variable lists
    let selectedCountiesArray: string[] = null;
    const selectedDropdownIds: string[] = this.juvenileSearchFormGroup.get('nameSearch.counties').value;
    if (selectedDropdownIds && selectedDropdownIds.length && selectedDropdownIds.length < this.counties.length) {
      const selectedIMultiSelectOptions = this.counties.filter(v => selectedDropdownIds.indexOf(v.id) !== -1);
      const selectedDropdownNames: string[] = selectedIMultiSelectOptions.map(o => o.name);
      selectedCountiesArray = selectedDropdownNames;
    }
    return selectedCountiesArray ? selectedCountiesArray.join(', ') : 'ALL';
  }

  getIdentitySearchCases(): CourtCase[] {
    return this.caseSearchResults && this.caseSearchResults.cases;
  }
  doesIdentitySearchCasesHaveMoreRecords(): boolean {
    return !!this.caseSearchResults &&
      (this.caseSearchResults.totalRecords >
        this.caseSearchResults.pageNumber * this.caseSearchResults.pageSize);
  }

  getNextIdentitySearchCases() {
    this.searchCriteriaDescription = null;
    this.juvenileSearchFormGroup.get('nameSearch.casesPageNumber').setValue(this.caseSearchResults.pageNumber + 1);
    this.search();
  }

  getTotalRecordsDescription(): string {
    if (!this.caseSearchResults || !this.caseSearchResults.totalRecords) {
      return '';
    }

    let result = '';

    if (this.caseSearchResults.totalRecords === 1) {
      result = ' Juvenile found';
    } else {
      result = ' Juveniles found';
    }

    return (this.caseSearchResults.totalRecords).toLocaleString() + result;
  }

  getDisplayedRecordsDescription(): string {
    if (!this.caseSearchResults || !this.caseSearchResults.totalRecords) {
      return '';
    }
    return (this.caseSearchResults.pageNumber * JuvenileSearchConstants.PAGE_SIZE).toLocaleString()
      + ' of ' + (this.caseSearchResults.totalRecords).toLocaleString()
      + ' juveniles are being displayed. ';
  }

  public setMaxLength(): boolean {
    if (this.juvenileSearchFormGroup.get('nameSearch.searchBy').value === 'Name') {
      return true;
    }

    if (this.juvenileSearchFormGroup.get('nameSearch.searchBy').value === 'NCJoinNumber') {
      return false;
    }
  }

  public setDefaultYear(): void {
    if (this.juvenileSearchFormGroup.get('nameSearch.fromYear').value === null) {
      this.juvenileSearchFormGroup.get('nameSearch.fromYear').setValue(this.minYear);
    }

    if (this.juvenileSearchFormGroup.get('nameSearch.toYear').value === null) {
      this.juvenileSearchFormGroup.get('nameSearch.toYear').setValue(this.maxYear);
    }
  }

  leftPadZeros(): void {
    if (this.juvenileSearchFormGroup.get('nameSearch.searchBy').value === 'NCJoinNumber') {
      let formattedNCJoinNum = '';
      const trimmedValue =
        this.juvenileSearchFormGroup.get('nameSearch.searchValue').value ?
          this.juvenileSearchFormGroup.get('nameSearch.searchValue').value.trim() : '';

      if (trimmedValue.length > 0) {
        switch (trimmedValue.length) {
          case 1: formattedNCJoinNum = '000000' + trimmedValue; break;
          case 2: formattedNCJoinNum = '00000' + trimmedValue; break;
          case 3: formattedNCJoinNum = '0000' + trimmedValue; break;
          case 4: formattedNCJoinNum = '000' + trimmedValue; break;
          case 5: formattedNCJoinNum = '00' + trimmedValue; break;
          case 6: formattedNCJoinNum = '0' + trimmedValue; break;
          default: formattedNCJoinNum = trimmedValue; break;
        }
        this.juvenileSearchFormGroup.get('nameSearch.searchValue').setValue(formattedNCJoinNum);
      }
    }
  }

  private validateNcJoinNumber(group: FormGroup): ValidationErrors | null {

    // if(!isNullOrUndefined(group.get('searchValue').value)) {
    const trimmedValue = group.get('searchValue').value ? group.get('searchValue').value.trim() : '~';
    // this.juvenileSearchFormGroup.get('nameSearch').clearValidators;
    if (trimmedValue === '~') {
      return null;
    }

    if (group.get('searchBy').value === 'NCJoinNumber') {
      if (trimmedValue === '') {
        return { nonNumeric: true, emptyFlag: true };
      } else {
        // const isFieldEmpty = /^$/.test(trimmedValue);
        // if(isFieldEmpty) return {isFieldEmpty2: true};
        const nonDigitFound = /\D/.test(trimmedValue);
        return nonDigitFound ? { nonNumeric: true, emptyFlag: false } : null;
      }
    } else if (group.get('searchBy').value === 'Name') {
      // const trimmedValue = group.get('searchValue').value ? group.get('searchValue').value.trim() : '';
      if (trimmedValue === '') {
        return { nameValCheck: true, emptyFlag: true };
      } else {
        // const isFieldEmpty = /^$/.test(trimmedValue);
        // if(isFieldEmpty) return {isFieldEmpty1: true};
        if (trimmedValue.indexOf('%') > -1) {
          return { nameValCheck: true, emptyFlag: false };
        } else {
          return null;
        }
      }
    } else {
      return null;
    }
    // }// else return null;

  }

  /**
   * validator for checking if the from year is greater than through year
   * @param group
   */
  isFromYearGreater(group: FormGroup) {
    const fromYear: FormControl = group.controls.fromYear as FormControl;
    const toYear: FormControl = group.controls.toYear as FormControl;
    if (!fromYear || !toYear || !fromYear.value || !toYear.value) {
      return null;
    }
    if (fromYear.value <= toYear.value) {
      return null;
    }
    return { isFromYearGreater: true };
  }

  toggleFieldCodes() {
    this.showFieldCodeFlag = !this.showFieldCodeFlag;
    $('.field-code').toggle();
  }

  /**
   * Due to Angular validation has less access points for setting validators for different event in
   * the validator configuration (still seeking the solution in this way),  Meanwhile, just reset
   * validators and update validity for the form controls as well as the form group (if necessary)
   * to achieve the validation requirement specifications.
   *
   * @param $event Event
   * @param formControlName: string
   * @param formName: string
   */
  updateValidity($event, formControlName: string, formName: string) {
    if ($event.type === 'blur') {
      if (this.juvenileSearchFormGroup.get(formControlName).value === null) {
        this.onBlurEventCalled = true;
        return;
      }
      // on blur - instant validation
      this.juvenileSearchFormGroup.get(formControlName).clearAsyncValidators();
      if (formControlName.indexOf('caseNumber') >= 0) {
        this.juvenileSearchFormGroup.get(formControlName).setValidators(this.caseNumberValidators);
      } else if (formControlName.indexOf('fromYear') >= 0 || formControlName.indexOf('toYear') >= 0) {
        this.juvenileSearchFormGroup.get(formControlName).setValidators(this.yearValidators);
        this.juvenileSearchFormGroup.get(formName).setAsyncValidators(null);
        this.juvenileSearchFormGroup.get(formName).setValidators([this.isFromYearGreater]);
      }
      this.juvenileSearchFormGroup.get(formControlName).updateValueAndValidity();
    } else if ($event.type === 'focus') {
      this.onBlurEventCalled = false;
      this.juvenileSearchFormGroup.get('caseLookup.caseNumber').setErrors({ 'blur': false, 'required': false });
      // on focus -instant validation if initial value entry exists upon focus, else asychrous validation
      if (this.juvenileSearchFormGroup.get(formControlName).value !== null
        && this.juvenileSearchFormGroup.get(formControlName).value !== undefined
        && this.juvenileSearchFormGroup.get(formControlName).value.length > 0) {
        this.juvenileSearchFormGroup.get(formControlName).clearAsyncValidators();
        if (formControlName.indexOf('caseNumber') >= 0) {
          this.juvenileSearchFormGroup.get(formControlName).setValidators(this.caseNumberValidators);
        } else if (formControlName.indexOf('fromYear') >= 0 || formControlName.indexOf('toYear') >= 0) {
          this.juvenileSearchFormGroup.get(formControlName).setValidators(this.yearValidators);
          // set form validation to asynch
          this.juvenileSearchFormGroup.get(formName).setAsyncValidators([asyncFromGreater('fromYear', 'toYear', this.delayTime)]);
          this.juvenileSearchFormGroup.get(formName).setValidators(null);
        }
        this.juvenileSearchFormGroup.get(formControlName).updateValueAndValidity();
      } else {
        this.juvenileSearchFormGroup.get(formControlName).clearValidators();
        if (formControlName.indexOf('caseNumber') >= 0) {
          this.juvenileSearchFormGroup.get(formControlName).setValidators([Validators.required]);
          this.juvenileSearchFormGroup.get(formControlName).setAsyncValidators(this.caseNumberAsyncValidators);
        } else if (formControlName.indexOf('fromYear') >= 0 || formControlName.indexOf('toYear') >= 0) {
          this.juvenileSearchFormGroup.get(formControlName).setAsyncValidators(this.yearAsyncValidtors);
          // set form validation to asynch
          this.juvenileSearchFormGroup.get(formName).setAsyncValidators([asyncFromGreater('fromYear', 'toYear', this.delayTime)]);
          this.juvenileSearchFormGroup.get(formName).setValidators(null);
        }
        this.juvenileSearchFormGroup.get(formControlName).updateValueAndValidity();
      }
    } else if ($event.type === 'keypress') {
      let keyCode = (typeof $event.which === 'number') ? $event.which : $event.keyCode;
      // key press - instant validation for enter key;
      //             instant validation for initial value exists and invalid status upon key press;
      //             asynchrous validation for initial value empty or valid status upon key press
      //                                     (stauts may be continuously updated in asynchrous validation)
      if (keyCode === 13) {  // key press - enter key
        this.juvenileSearchFormGroup.get(formControlName).clearAsyncValidators();
        if (formControlName.indexOf('caseNumber') >= 0) {
          this.juvenileSearchFormGroup.get(formControlName).setValidators(this.caseNumberValidators);
        } else if (formControlName.indexOf('fromYear') >= 0 || formControlName.indexOf('toYear') >= 0) {
          this.juvenileSearchFormGroup.get(formControlName).setValidators(this.yearValidators);
          this.juvenileSearchFormGroup.get(formName).setAsyncValidators(null);
          this.juvenileSearchFormGroup.get(formName).setValidators([this.isFromYearGreater]);
        }
        this.juvenileSearchFormGroup.get(formControlName).updateValueAndValidity();
      } else {                // key press - any other key
        if (this.juvenileSearchFormGroup.get(formControlName).value !== null
          && this.juvenileSearchFormGroup.get(formControlName).value !== undefined
          && this.juvenileSearchFormGroup.get(formControlName).value.length > 1
          && this.juvenileSearchFormGroup.get(formControlName).invalid) {
          this.juvenileSearchFormGroup.get(formControlName).clearAsyncValidators();
          if (formControlName.indexOf('caseNumber') >= 0) {
            this.juvenileSearchFormGroup.get(formControlName).setValidators(this.caseNumberValidators);
          } else if (formControlName.indexOf('fromYear') >= 0 || formControlName.indexOf('toYear') >= 0) {
            this.juvenileSearchFormGroup.get(formControlName).setValidators(this.yearValidators);
            // set form validation to asynch
            this.juvenileSearchFormGroup.get(formName).setAsyncValidators([asyncFromGreater('fromYear', 'toYear', this.delayTime)]);
            this.juvenileSearchFormGroup.get(formName).setValidators(null);
          }
          this.juvenileSearchFormGroup.get(formControlName).updateValueAndValidity();
        } else {
          this.juvenileSearchFormGroup.get(formControlName).clearValidators();
          if (formControlName.indexOf('caseNumber') >= 0) {
            this.juvenileSearchFormGroup.get(formControlName).setValidators([Validators.required]);
            this.juvenileSearchFormGroup.get(formControlName).setAsyncValidators(this.caseNumberAsyncValidators);
          } else if (formControlName.indexOf('fromYear') >= 0 || formControlName.indexOf('toYear') >= 0) {
            this.juvenileSearchFormGroup.get(formControlName).setAsyncValidators(this.yearAsyncValidtors);
            // set form validation to asynch
            this.juvenileSearchFormGroup.get(formName).setAsyncValidators([asyncFromGreater('fromYear', 'toYear', this.delayTime)]);
            this.juvenileSearchFormGroup.get(formName).setValidators(null);
          }
          this.juvenileSearchFormGroup.get(formControlName).updateValueAndValidity();
        }
      }
    }
  }

  isProd(): boolean {
    return environment.production;
  }

  isRequestInFlight(): boolean {
    return this.requestSubscription &&
      !this.requestSubscription.closed;
  }

  private getLoggedInUser(): any {
    return this.loggedInUser;
  }

}



// WEBPACK FOOTER //
// /home/jenkins/workspace/pipeline-ciprs-ui-final/project/src/app/juvenile/juvenile.component.ts